<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600px">
    <template v-slot:title>Select Participants</template>
    <v-data-table
      :items="itineraryParticipantsWithGroups"
      :headers="headers"
      v-model="selected"
      show-select
    >
    </v-data-table>
    <template v-slot:actions>
      <v-btn color="primary" @click="onAdd" :disabled="selected.length == 0"
        >Add</v-btn
      >
    </template>
    <div v-if="debug">
      <code>{{ itineraryParticipants }}</code>
      <code>{{ scenarios }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "scenario-add-participants-dialog",

  props: {
    itineraryParticipants: {
      type: Array,
      default: () => [],
    },

    show: {
      type: Boolean,
      default: () => false,
    },
    scenarios: {
      type: Array,
      default: () => [],
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      selected: [],
      headers: [
        {
          text: "Title",
          align: "left",
          value: "title",
          name: "title",
        },
        {
          text: "Name",
          align: "left",
          value: "name",
          name: "name",
        },
        {
          text: "Surname",
          align: "left",
          value: "surname",
          name: "surname",
        },
        {
          text: "Assigned to",
          align: "left",
          value: "groups",
          name: "groups",
        },
      ],
    };
  },

  computed: {
    itineraryParticipantsWithGroups() {
      return this.itineraryParticipants.map((p) => {
        const groupsForParticipant = this.scenarios.filter((s) =>
          s.participants.some(
            (pp) =>
              pp.name === p.name &&
              pp.surname === p.surname &&
              pp.title === p.title
          )
        );
        return {
          ...p,
          groups: groupsForParticipant.map((g) => g.name).join(", "),
        };
      });
    },
  },
  methods: {
    onAdd() {
      this.$emit("add", [...this.selected]);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/scenarios/ScenarioAddParticipantsDialog.vue